import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type IntegrationTelemetryConfigService from 'garaje/services/integration-telemetry-config';
import { GLOBAL_ADMIN } from 'garaje/utils/roles';
import _intersection from 'lodash/intersection';

const CAN_VISIT_ROLES = [GLOBAL_ADMIN];

export default class GlobalHealthDashboardAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare integrationTelemetryConfig: IntegrationTelemetryConfigService;

  get canVisit(): boolean {
    if (!this.featureFlags.isEnabled('integration-health-dashboard')) return false;
    this.integrationTelemetryConfig.ensureGlobalLoaded();
    if (!this.integrationTelemetryConfig.hasDataForGlobal) return false;
    return isPresent(_intersection(CAN_VISIT_ROLES, this.currentAdmin.roleNames));
  }
}
